import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IModuleUserDateRangeFilters } from 'app/library/module-user/interfaces/module-user-date-range-filters.interface';
import { IModuleUserQuery } from 'app/library/module-user/interfaces/module-user.query.interface';
import { appendModuleUserDateRangeFilters } from 'app/library/module-user/utils/module-user-date-range-filters.util';
import { IEnvironment } from 'app/projects/core/src/lib/interfaces/environment.interface';
import { MAXBRAIN_ENVIRONMENT } from 'app/projects/core/src/lib/services/environment.token';
import { IPaginatedResponse } from 'app/projects/subentity/src/lib/interfaces/paginated-response.interface';
import { Observable } from 'rxjs';

export interface IModuleUsersResponse extends IPaginatedResponse<IModuleUserQuery> {
    user_ids?: number[];
    module_user_ids?: number[];
}

@Injectable()
export class ModuleParticipantsApiService {
    constructor(private http: HttpClient, @Inject(MAXBRAIN_ENVIRONMENT) private environment: IEnvironment) {}

    getAll(
        moduleId = '',
        search = '',
        sortBy = '',
        sortOrder = '',
        pageSize = 10,
        pageIndex = 1,
        withoutCertificate?: boolean,
        selectedCertificateIds?: string[],
        selectedProgressStatuses?: string[],
        dateRangeFilters?: IModuleUserDateRangeFilters
    ): Observable<IModuleUsersResponse> {
        let params = new HttpParams()
            .set('page', pageIndex ? pageIndex.toString() : '1')
            .set('limit', pageSize ? pageSize.toString() : '50')
            .set('module', moduleId)
            .set('isParticipant', 'true');

        if (search) {
            params = params.set('search', search);
        }

        if (sortBy && sortOrder) {
            if (sortBy === 'name' || sortBy === 'fullName') {
                sortBy = 'name';
            }

            params = params.set('sortBy', `${sortBy}`);
            params = params.set('sortOrder', sortOrder);
        }

        if (selectedCertificateIds && selectedCertificateIds.length) {
            params = params.set('filter[certificate]', selectedCertificateIds.toString());
        }

        if (withoutCertificate) {
            params = params.set('filter[withoutCertificate]', String(withoutCertificate));
        }

        if (selectedProgressStatuses && selectedProgressStatuses.length) {
            params = params.set('filter[progressStatus]', selectedProgressStatuses.toString());
        }

        if (dateRangeFilters) {
            params = appendModuleUserDateRangeFilters(params, dateRangeFilters);
        }

        return this.http.get<IModuleUsersResponse>(`${this.environment.apiUrl}/modules-users`, { params });
    }
}
